/**
 * ScopeBadge Component
 * Shows marketplace scope indicator (My Network / Public Market)
 * Professional styling with tooltips and visual differentiation
 */

import React from 'react';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';

const SCOPE_CONFIG = {
    network: {
        label: 'My Network',
        shortLabel: 'Network',
        icon: 'pi-users',
        severity: 'info',
        description: 'Listed within your organization network',
        color: '#3b82f6',
        bgColor: '#eff6ff'
    },
    tenant: {
        label: 'My Network',
        shortLabel: 'Network',
        icon: 'pi-users',
        severity: 'info',
        description: 'Listed within your organization network',
        color: '#3b82f6',
        bgColor: '#eff6ff'
    },
    public: {
        label: 'Public Market',
        shortLabel: 'Public',
        icon: 'pi-globe',
        severity: 'success',
        description: 'Listed on the public marketplace for all agents',
        color: '#22c55e',
        bgColor: '#f0fdf4'
    },
    central: {
        label: 'Public Market',
        shortLabel: 'Public',
        icon: 'pi-globe',
        severity: 'success',
        description: 'Listed on the public marketplace for all agents',
        color: '#22c55e',
        bgColor: '#f0fdf4'
    }
};

const ScopeBadge = ({
    scope,
    size = 'normal',
    showTooltip = true,
    showIcon = true,
    className = ''
}) => {
    const normalizedScope = scope?.toLowerCase() || 'public';
    const config = SCOPE_CONFIG[normalizedScope] || SCOPE_CONFIG.public;
    const uniqueId = `scope-badge-${Math.random().toString(36).substr(2, 9)}`;

    // Small compact version
    if (size === 'small') {
        return (
            <>
                <Tag
                    id={uniqueId}
                    value={config.shortLabel}
                    icon={showIcon ? `pi ${config.icon}` : null}
                    severity={config.severity}
                    className={`text-xs ${className}`}
                />
                {showTooltip && (
                    <Tooltip target={`#${uniqueId}`} position="top">
                        <div className="text-center p-1">
                            <div className="font-semibold">{config.label}</div>
                            <div className="text-xs text-300 mt-1">{config.description}</div>
                        </div>
                    </Tooltip>
                )}
            </>
        );
    }

    // Large decorative version
    if (size === 'large') {
        return (
            <div
                className={`flex align-items-center gap-2 px-3 py-2 border-round-lg ${className}`}
                style={{
                    backgroundColor: config.bgColor,
                    border: `1px solid ${config.color}20`
                }}
            >
                <i
                    className={`pi ${config.icon}`}
                    style={{ color: config.color, fontSize: '1.25rem' }}
                />
                <div>
                    <div className="font-semibold" style={{ color: config.color }}>
                        {config.label}
                    </div>
                    <div className="text-500 text-xs">{config.description}</div>
                </div>
            </div>
        );
    }

    // Normal version
    return (
        <>
            <Tag
                id={uniqueId}
                value={config.label}
                icon={showIcon ? `pi ${config.icon}` : null}
                severity={config.severity}
                className={className}
            />
            {showTooltip && (
                <Tooltip target={`#${uniqueId}`} position="top">
                    <div className="p-1">{config.description}</div>
                </Tooltip>
            )}
        </>
    );
};

export default ScopeBadge;
